/**
 * Every campaign text the Tetori Rozë 2026 theme draws itself. The questions, their options and
 * the gender logic live in the survey (XLSForm) - this file only holds the page around them.
 *
 * `null` links are deliberate placeholders: fill them with the validated campaign material once it
 * exists. A card without a link renders as plain text; the call-to-action stays hidden.
 */
export const content = {
   hero: {
      logos: {
         ksAps: "KS-APS",
         amc: "AMC - Action for Mothers and Children",
         poweredBy: "Powered by",
         kapSurvey: "KAPsurvey"
      },
      titleLead: "Tetori",
      titleAccent: "Rozë 2026",
      subtitle: "Sa dimë. Si ndihemi. Çfarë bëjmë.",
      description:
         "Një anketë e shkurtër për të kuptuar njohuritë, qëndrimet dhe praktikat e grave dhe burrave në Kosovë lidhur me kancerin e gjirit.",
      facts: [
         { key: "time", label: "3–4 minuta" },
         { key: "anonymous", label: "Anonime" },
         { key: "voluntary", label: "Vullnetare" }
      ]
   },

   // The information window shown on the first visit, until the respondent presses the button.
   welcome: {
      title: "SA DI PËR KANCERIN E GJIRIT?",
      questions: [
         "A do t’i njihnit shenjat paralajmëruese?",
         "A e dini kur duhet të kërkoni ndihmë?",
         "Dhe a e dini se kanceri i gjirit mund të prekë edhe meshkujt?"
      ],
      text:
         "Këtë tetor, KS-APS bëhet Pink me KAPsurvey, për të rritur ndërgjegjësimin dhe për të kuptuar më mirë nevojat e komunitetit tonë.",
      highlight: "💗 Kushtoni 3 minuta për shëndetin tuaj dhe të njerëzve që doni.",
      callToAction:
         "Plotësoni sondazhin, ndani informacionin dhe ndihmoni që mesazhi i ndërgjegjësimit të arrijë te sa më shumë njerëz.",
      confirm: "Në rregull"
   },

   // XLSForm group whose step is the "Mirë se vini!" consent screen. It gets no section number and
   // no place in the progress count.
   introSectionName: "hyrje",

   card: {
      languageLabel: "Gjuha e anketës",
      printLabel: "Printo anketën",
      // The API names languages in English; show the respondent their own language's name.
      languageNames: {
         Albanian: "Shqip"
      },
      // The "Pyetja N:" prefix itself is drawn in CSS (tetoriRoze.scss), so hidden questions are
      // never counted.
      progressLabel: (position, total) => `Seksioni ${position} nga ${total}`
   },

   actions: {
      seeDrafts: "Shih draftet e ruajtura",
      saveDraft: "Ruaj si draft",
      back: "Kthehu",
      next: "Vazhdo",
      finish: "Përfundo",
      processing: "Duke dërguar...",
      requiredMissing: "Ju lutem përgjigjuni pyetjeve të shënuara para se të vazhdoni.",
      constraintFailed: "Ju lutem kontrolloni përgjigjet e shënuara para se të vazhdoni."
   },

   completion: {
      title: "Faleminderit!",
      subtitle: "Ju u bëtë pjesë e Tetorit Rozë.",
      text: "Informator për hapat e ekzaminimit të gjirit për gratë e Kryeqytetit",
      textHref:
         "https://amchealth.org/wp-content/uploads/2025/10/Informator-per-hapat-e-ekzaminimit-te-gjirit-FINAL.pdf",
      alreadySubmitted: "Ju e keni plotësuar tashmë këtë anketë.",
      kioskReset: "Anketa do të rifillojë pas pak për personin e radhës.",
      cards: [
         {
            key: "signs",
            title: "Njihni shenjat",
            text: "Zbulimi i hershëm rrit ndjeshëm shanset për trajtim të suksesshëm.",
            // Placeholder: validated medical content about the signs.
            href: null
         },
         {
            key: "self-exam",
            title: "Njihni trupin tuaj",
            text: "Mësoni si ta bëni vetëkontrollin e gjirit në 5 hapa të thjeshtë.",
            // Placeholder: the self-examination guidance (5 steps).
            href: null
         },
         {
            key: "check-up",
            title: "Mos e shtyni kontrollin",
            text: "Informohuni ku dhe si mund të bëni kontroll te partnerët e fushatës.",
            // Placeholder: the campaign partners' contact details. Never invent these.
            href: null
         }
      ],
      cta: {
         label: "Më shumë informacione",
         // Placeholder: the campaign's information page. The button shows once this is set.
         href: null
      }
   },

   onlineHelp: {
      title: "Formulari funksionon edhe pa internet!",
      paragraphs: [
         "Ky formular mund të plotësohet edhe pa lidhje interneti në pajisjen tuaj. Ruajeni si faqe të preferuar për ta hapur shpejt edhe offline.",
         "Përgjigjet tuaja ruhen në mënyrë të sigurt në shfletues derisa të riktheheni online. Sapo të keni sërish internet dhe ta rihapni faqen, të gjitha përgjigjet dërgohen automatikisht.",
         "Një përgjigje hiqet nga radha vetëm pasi të jetë dërguar me sukses. Mund ta mbyllni shfletuesin ose pajisjen pa problem edhe kur ka përgjigje në pritje."
      ]
   }
};
